/**
 * Web (Stripe) membership prices shown in the UI.
 *
 * Keep these in sync with the live Stripe prices behind
 * REACT_APP_STRIPE_PREMIUM_MONTHLY_PRICE_ID / REACT_APP_STRIPE_PREMIUM_ANNUAL_PRICE_ID.
 * client/scripts/prerender.js repeats them in the /membership SEO copy.
 * The native app shows App Store prices from RevenueCat instead.
 */

export const MONTHLY_PRICE_USD = 5.99;
export const ANNUAL_PRICE_USD = 29.99;

export const formatUsd = (amount: number): string => `$${amount.toFixed(2)}`;

/** Annual price spread over 12 months, e.g. $29.99 → "$2.50". */
export const ANNUAL_MONTHLY_EQUIVALENT = formatUsd(ANNUAL_PRICE_USD / 12);
export const MONTHLY_PRICE = formatUsd(MONTHLY_PRICE_USD);
export const ANNUAL_PRICE = formatUsd(ANNUAL_PRICE_USD);
